import React from 'react';
import Menu from '../Menu/Menu';
import Footer from '../Footer/Footer';
import './private-page.css';

const WIDTH_CLASS = {
    narrow: 'private-page--narrow',
    wide: '',
    full: 'private-page--full',
};

/**
 * props:
 * - children
 * - width: 'narrow' | 'wide' | 'full'
 * - showFooter: boolean (default true)
 * - className
 */
export function PrivatePageLayout(props) {
    const {
        children,
        width = 'wide',
        showFooter = true,
        className = '',
    } = props;

    const pageClass = [
        'private-page',
        WIDTH_CLASS[width] || '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <main className="flex bg-blue-100">
            <Menu />
            <section className="private-page-section">
                <div className={pageClass}>
                    {children}
                </div>
                {showFooter ? <Footer /> : null}
            </section>
        </main>
    );
}

export default PrivatePageLayout;